var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1602 22.5586V50.877H31.166V22.5586H31.1602Z",
    fill: "#343535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3105 29.127H44.3496V30.0645H39.3105V29.127ZM39.3105 36.627H44.3496V37.5645H39.3105V36.627ZM13.7051 14.127H18.7441V15.0645H13.7051V14.127ZM22.5 14.127H27.5391V15.0645H22.5V14.127ZM13.7051 21.6211H18.7441V22.5586H13.7051V21.6211ZM22.5 21.6211H27.5391V22.5586H22.5V21.6211ZM13.7109 29.1504H18.75V30.0879H13.7109V29.1504ZM22.5 29.1328H27.5391V30.0703H22.5V29.1328Z",
    fill: "#39393A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3379 41.2734C22.6406 40.5762 21.6738 40.1426 20.6133 40.1426C18.4922 40.1426 16.7578 41.877 16.7578 43.998V50.877H17.9297V43.998C17.9297 43.2832 18.2109 42.6152 18.7207 42.1055C19.2305 41.5957 19.9043 41.3145 20.6133 41.3145C21.3281 41.3145 21.9961 41.5957 22.5059 42.1055C23.0156 42.6152 23.2969 43.2891 23.2969 43.998V50.877H24.4688V43.998C24.4688 42.9375 24.0352 41.9766 23.3379 41.2734Z",
    fill: "#E73B37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7383 25.1367V50.7949H33.7441V25.1367H33.7383Z",
    fill: "#343535"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 50.877V22.5586H33.7441V6.53906H7.5V50.877H3.75V53.4551H56.25V50.877H52.5ZM31.166 50.877H10.0781V9.11719H31.166V50.877ZM49.9219 50.7891H33.7383V25.1367H49.9219V50.7891Z",
    fill: "#39393A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.e63909cd069d69a3fe032cd15bd15635.svg";
export { ForwardRef as ReactComponent };